import type { MatterMember } from '@/types/base';
import type { Task } from './columns-tasks';
import { STATUS_OPTIONS } from '@/components/tasks/constants';

// `customDateFilter` and `highlightText` live in column-utilities (the shared
// table-utility module). Re-export them here so existing task-column importers
// keep working without a duplicate implementation.
export { customDateFilter, highlightText } from './column-utilities';

export const statusOptions = STATUS_OPTIONS;

export const getCreatedByOptions = (tasks: Task[]) => {
  const options: { label: string; value: string }[] = [];
  const seen = new Set<string>();
  
  if (tasks.some(t => !t.created_by)) {
    options.push({ label: 'Extracted', value: '' });
    seen.add('');
  }
  
  tasks.forEach(task => {
    if (task.created_by && task.created_by_name) {
      const createdByStr = String(task.created_by);
      if (!seen.has(createdByStr)) {
        options.push({ label: task.created_by_name, value: createdByStr });
        seen.add(createdByStr);
      }
    }
  });
  
  return options;
};

export const getAssigneeOptions = (members: MatterMember[]) => {
  const options: { label: string; value: string }[] = [
    { label: 'Unassigned', value: 'unassigned' }
  ];
  
  members.forEach(member => {
    if (member.user_guid && member.name) {
      options.push({ 
        label: member.name, 
        value: member.user_guid
      });
    }
  });
  
  return options;
};
